"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAlturaConteudoStyled = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var alturaHeaderMobile = '72px';
var alturaHeaderDesktop = '80px';
/**
 * @description
 * Estilo usado para aplicar a altura do viewport desconsiderando o cabeçalho da aplicação
 */
exports.BaseAlturaConteudoStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  @media only screen and (max-width: ", "px) {\n    ", ";\n  }\n"], ["\n  ", ";\n\n  @media only screen and (max-width: ", "px) {\n    ", ";\n  }\n"])), function (_a) {
    var descontarHeight = _a.descontarHeight;
    return descontarHeight
        ? "height: calc(100vh - (".concat(alturaHeaderDesktop, " + ").concat(descontarHeight, "))")
        : "height: calc(100vh - ".concat(alturaHeaderDesktop, ")");
}, function (props) { return props.theme.md; }, function (_a) {
    var descontarHeight = _a.descontarHeight;
    return descontarHeight
        ? "height: calc(100vh - (72px + ".concat(descontarHeight, "))")
        : "height: calc(100vh - ".concat(alturaHeaderMobile, ")");
});
var templateObject_1;
